import React, { useState } from 'react';
import { X, Eye, EyeOff } from 'lucide-react';

interface PasswordModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: () => void;
  password: string;
  setPassword: (value: string) => void;
  passwordError: string;
  setPasswordError: (value: string) => void;
}

const PasswordModal: React.FC<PasswordModalProps> = ({
  isOpen,
  onClose,
  onSubmit,
  password,
  setPassword,
  passwordError,
  setPasswordError
}) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleClose = () => {
    onClose();
    setPassword('');
    setPasswordError('');
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 !bg-black/50 flex items-center justify-center z-50">
      <div className="!bg-white dark:!bg-gray-800 rounded-md p-6 w-full max-w-md mx-4 shadow-xl">
        <div className="flex items-start justify-between mb-4">
          <h3 className="!text-base !font-medium !text-gray-900 dark:!text-white pr-4">
            Đã đảm bảo tài khoản của bạn luôn an toàn, vui lòng nhập mật khẩu của bạn
          </h3>
          <button
            onClick={handleClose}
            className="!bg-transparent !border-none !text-gray-400 hover:!text-gray-600 dark:hover:!text-gray-300 !p-1"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        <div className="mt-6 mb-6">
          <div className="relative">
            <input
              type={showPassword ? 'text' : 'password'}
              placeholder="Mật khẩu"
              value={password}
              onChange={(e) => {
                setPassword(e.target.value);
                setPasswordError('');
              }}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  onSubmit();
                }
              }}
              className={`w-full !px-4 !py-3 !border ${passwordError ? '!border-red-500' : '!border-gray-300 dark:!border-gray-600'} rounded-md !bg-white dark:!bg-gray-700 !text-gray-900 dark:!text-white placeholder:!text-gray-400 focus:!outline-none focus:!ring-2 ${passwordError ? 'focus:!ring-red-500' : 'focus:!ring-blue-500'}`}
            />
            <button
              type="button"
              onClick={() => setShowPassword(!showPassword)}
              className="absolute right-3 top-1/2 -translate-y-1/2 !bg-transparent !border-none !text-gray-400 hover:!text-gray-600 dark:hover:!text-gray-300"
            >
              {showPassword ? <EyeOff className="w-5 h-5" /> : <Eye className="w-5 h-5" />}
            </button>
          </div>
          {passwordError && (
            <p className="!text-sm !text-red-500 mt-2">{passwordError}</p>
          )}
        </div>

        <div className="flex gap-3">
          <button
            onClick={handleClose}
            className="flex-1 !px-4 !py-2.5 !border !border-gray-300 dark:!border-gray-600 rounded-md !text-gray-700 dark:!text-gray-300 hover:!bg-gray-50 dark:hover:!bg-gray-700 !transition-colors !bg-white dark:!bg-gray-800 !font-medium"
          >
            Hủy
          </button>
          <button
            onClick={onSubmit}
            className="flex-1 !px-4 !py-2.5 !bg-primary !text-white rounded-md hover:!bg-yellow-600 !transition-colors !border-none !font-medium"
          >
            Xác nhận
          </button>
        </div>
      </div>
    </div>
  );
};

export default PasswordModal;
